import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {
    PERMISSION_TALENTS_READ
  } from '../../../constants'
import {buildUrlFromParams} from '../../common/functions/url'
import {takeExcelFile} from '../../common/functions/excelExport'
import {checkPermission, permissionByProfileType} from '../../common/functions/permissions'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import {VOICE_TEST_CANDIDATE_STATUS_PREHIRED, VOICE_TEST_CANDIDATE_STATUS_HIRED, VOICE_TEST_CANDIDATE_STATUS_PRECONFIRMED, VOICE_TEST_CANDIDATE_STATUS_CONFIRMED} from '../../../constants'
import {clearVoiceTestCandidates, fetchVoiceTestCandidatesSuccess} from '../../../actions/pages/voice-test-page'
import Table from '../../../tables/reactable/DefaultTable'
import SkillLevel from '../../common/helpers/SkillLevel'
import StatusBadge from '../../common/helpers/StatusBadge'
import ProtectedElement from '../../common/helpers/ProtectedElement'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import SamplesBox from '../../skillvendor-admin/profile/helpers/SamplesBox'
import RemoteSamplesBox from '../../skillvendor-admin/profile/helpers/RemoteSamplesBox'
import AudioPlayer from '../../common/helpers/AudioPlayer'

class CandidatesList extends Component {
  constructor(props) {
    super(props)
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.prehireCandidate = this.prehireCandidate.bind(this)
    this.hireCandidate = this.hireCandidate.bind(this)
    this.cancelCandidate = this.cancelCandidate.bind(this)
    this.exportCandidates = this.exportCandidates.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.toggle = this.toggle.bind(this)
    this.state = {
      itemsPerPage: 10,
      search: '',
      filter: {
        Status: this.defaultFilter()
      },
      modal: false,
      className: 'modal-primary',
      size: 'default',
      avatarUrl: '',
      talentId: '',
      profileData: null
    }
  }

  componentDidMount() {
    if (this.props.candidates === null){
      this.fetchCandidates();
    }

    this.setState({
      columns: [
        'AvatarImage',
        'FullName',
        'FullNameForSearch',
        'ProdubNumber',
        'SkillLevel',
        'Status',
        'Actions'
      ],
      columnNames: [
        '',
        'Full name',
        'FullNameForSearch',
        'Number',
        this.props.overview.SkillTypeLabel,
        'Status',
        'Actions'
      ]
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.candidates === null){
      this.fetchCandidates();
    }
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  prehireCandidate(candidate) {
    let url = 'voicetests/' + this.props.voiceTestId + '/skillvendors/' + candidate.SkillVendorId + '/prehire'
    this.props.ajax.put(url, null, null, () => {
      this.props.clearVoiceTestCandidates();
      this.props.notify('The candidate was preconfirmed.');
    })
  }

  hireCandidate(candidate) {
    let url = 'voicetests/' + this.props.voiceTestId + '/skillvendors/' + candidate.SkillVendorId + '/hire'
    this.props.ajax.put(url, null, null, () => {
      this.props.clearVoiceTestCandidates();
      this.props.notify('The candidate was confirmed.');
    })
  }

  cancelCandidate(candidate) {
    let url = 'voicetests/' + this.props.voiceTestId + '/skillvendors/' + candidate.SkillVendorId + '/cancel'
    this.props.ajax.put(url, null, null, () => {
      this.props.clearVoiceTestCandidates();
      this.props.notify('The candidate was cancelled.');
    })
  }

  fetchCandidates() {
    let url = 'voicetests/' + this.props.voiceTestId + '/candidates'

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        data[index].NavigationParam = data[index].SkillVendorId;
      });

      this.props.fetchVoiceTestCandidatesSuccess(data);
    });
  }

  exportCandidates() {
    let url = buildUrlFromParams(
      'voicetests/' + this.props.voiceTestId + '/exportCandidates',
      {
        noi18n: 'true'
      });

    this.props.ajax.get(url, true, (data) => {
      takeExcelFile(data);
    });
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }

  defaultFilter(){
    let candidates = this.props.overview.StatisticsOfCandidates;
    for (var i = candidates.length - 1; i >= 0; i--){
      if (candidates[i].Key == 'Confirmed' && candidates[i].Value > 0){
        return 'confirmed';
      } else if (candidates[i].Key == 'Pre Confirmed' && candidates[i].Value > 0) {
        return 'preconfirmed';
      } else if (candidates[i].Key == 'Applied' && candidates[i].Value > 0) {
        return 'applied';
      } else if (candidates[i].Key == 'Suggested' && candidates[i].Value > 0) {
        return 'suggested';
      }
    }
    return '';
  }

  toggle() {
   this.setState({
     modal: !this.state.modal,
     profileData: null
   })
  }

  getSamples(e, className, size, avatarUrl, fullName, talentId){
    e.preventDefault();
    this.setState({
      modal: !this.state.modal,
      className: className,
      size: size,
      avatarUrl: avatarUrl,
      fullName: fullName,
      talentId: talentId
    }, function(){
      var url = 'skillvendors/' + this.state.talentId + '/profiles/' + this.props.overview.ProfileType.toLowerCase();
      this.props.ajax.get(url, true, (data) => {
        this.setState({profileData: data})
      })
    });
  }

  render() {
    if (this.props.candidates === null) {
      return (<div />)
    }

    let prehireBtnVisible = this.props.overview.Status === 'Active';

    let items = this.props.candidates.map(item => {
      let prehireBtnVisibleForItem = prehireBtnVisible && !item.DoNotUse;
      if (prehireBtnVisibleForItem && (item.Status === VOICE_TEST_CANDIDATE_STATUS_PREHIRED || item.Status === VOICE_TEST_CANDIDATE_STATUS_HIRED || item.Status === VOICE_TEST_CANDIDATE_STATUS_PRECONFIRMED || item.Status === VOICE_TEST_CANDIDATE_STATUS_CONFIRMED)) {
        prehireBtnVisibleForItem = false;
      }

      return Object.assign({}, item, {
        Status: (<StatusBadge status={item.Status.toLowerCase()} statusLabel={item.StatusLabel} />),
        AvatarImage: item.AvatarImageUrl ? (<img src={item.AvatarImageUrl} style={{width: '50px'}} className="rounded-circle" alt="" />) : (null),
        FullName: checkPermission(PERMISSION_TALENTS_READ)
          ?
          (
            <span fullname={item.FullName}>
              <a href={'/talents/' + item.SkillVendorId + '/overview'}>{item.FullName}</a>
              {this.props.overview.ProfileType == 'VoiceActor' &&
                <a href="#" onClick={(e, className, size, avatarUrl, fullName, talentId) => this.getSamples(e, `modal-primary`, 'default', item.AvatarImageUrl,item.FullName, item.SkillVendorId)}>
                    <i style={{color: 'black'}} className="ion-icon ion-icon-1x ion-mic-a user-sample-icon"></i>
                </a>
              }
              {this.props.overview.ProfileType == 'Singer' &&
                <a href="#" onClick={(e, className, size, avatarUrl, fullName, talentId) => this.getSamples(e, `modal-primary`, 'default', item.AvatarImageUrl,item.FullName, item.SkillVendorId)}>
                    <i style={{color: 'black'}} className="ion-icon ion-icon-1x ion-music-note user-sample-icon"></i>
                </a>
              }
            </span>
          )
          : (<span fullname={item.FullName}>{item.FullName}</span>),
        FullNameForSearch: item.FullName,
        SkillLevel: (<SkillLevel skillLevel={item.SkillLevel} skillLevelLabel={item.SkillLevelLabel} skillLevelWeight={item.SkillLevelWeight} />),
        Actions: (<span>
            <ProtectedElement permission={permissionByProfileType(this.props.overview.ProfileType, 'Book')}>
              {prehireBtnVisibleForItem &&
                <button
                  className="btn btn-primary btn-rounded"
                  type="button"
                  style={{marginRight:10}}
                  onClick={(e) => this.prehireCandidate(item)}>
                  Preconfirm
                </button>
              }
              {(item.Status === VOICE_TEST_CANDIDATE_STATUS_PREHIRED || item.Status === VOICE_TEST_CANDIDATE_STATUS_PRECONFIRMED) &&
                <button
                  className="btn btn-primary btn-rounded"
                  type="button"
                  style={{marginRight:10}}
                  onClick={(e) => this.hireCandidate(item)}>
                  Confirm
                </button>
              }
              {(item.Status === VOICE_TEST_CANDIDATE_STATUS_PREHIRED || item.Status === VOICE_TEST_CANDIDATE_STATUS_HIRED || item.Status === VOICE_TEST_CANDIDATE_STATUS_PRECONFIRMED || item.Status === VOICE_TEST_CANDIDATE_STATUS_CONFIRMED) &&
                <button
                  className="btn btn-primary btn-rounded"
                  type="button"
                  onClick={(e) => this.cancelCandidate(item)}>
                  Cancel
                </button>
              }
            </ProtectedElement>
          </span>)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.state.columns}
          columnNames={this.state.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={false}
          sortable={[
            {
              column: 'FullName',
              sortFunction: function(a, b) {
                return a.props ? a.props.fullname.localeCompare(b.props.fullname): 0;
              }
            },
            'ProdubNumber',
            {
                column: 'Status',
                sortFunction: function(a, b){
                  return a.props.statusLabel.localeCompare(b.props.statusLabel);
                }
            },
            {
                column: 'SkillLevel',
                sortFunction: function(a, b){
                  return a.props.skillLevelWeight === b.props.skillLevelWeight ? 0 : (a.props.skillLevelWeight < b.props.skillLevelWeight ? 1 : -1);
                }
            }
          ]}
          defaultSort={{column: 'FullName', direction: 'asc'}}
          hiddenColumns={['FullNameForSearch']}
          searchable={[
            'ProdubNumber',
            'FullNameForSearch'
          ]}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[{
            column: 'Status',
            filters: [
              {
                value: 'matched',
                label: 'Matched'
              },
              {
                value: 'suggested',
                label: 'Suggested'
              },
              {
                value: 'applied',
                label: 'Applied'
              },
              {
                value: 'preconfirmed',
                label: 'Pre Confirmed'
              },
              {
                value: 'confirmed',
                label: 'Confirmed'
              }
            ]
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
        />
        <div className="mt-3">
          <button
            className="btn btn-primary btn-rounded"
            type="button"
            onClick={this.exportCandidates}>
            Export candidates
          </button>
        </div>
        {this.state.modal ?
          <Modal
           isOpen={this.state.modal}
           toggle={this.toggle}
           wrapClassName={this.state.className}
           size={this.state.size}>
           <ModalHeader toggle={this.toggle}>
            <div>
              <img src={this.state.avatarUrl} style={{width: '50px'}} className="rounded-circle" alt="" />
              <span style={{verticalAlign: 'middle', marginLeft: '10px'}}>{this.state.fullName}</span>
            </div>
           </ModalHeader>
           <ModalBody>
             {this.state.profileData !== null &&<SamplesBox profileData={this.state.profileData} classColumn={'col-md-12'}  />}
             {this.state.profileData !== null &&<RemoteSamplesBox profileData={this.state.profileData} classColumn={'col-md-12'} talent={false} />}
           </ModalBody>
           <ModalFooter>
             <button className="btn btn-default btn-rounded" onClick={this.toggle}>
               Close
             </button>
           </ModalFooter>
         </Modal>
        :null}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  candidates: state.voiceTestPage.candidates,
  overview: state.voiceTestPage.overview
})
const mapDispatchToProps = dispatch => ({
  clearVoiceTestCandidates() { dispatch(clearVoiceTestCandidates()) },
  fetchVoiceTestCandidatesSuccess(candidates) { dispatch(fetchVoiceTestCandidatesSuccess(candidates)) }
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(CandidatesList)
